export const adaptRegionPayload = (
	data: RegionFormValues
): Record<string, unknown> => {
	return {
		name: data.name,
		region_manager: data.regionManager ? Number(data.regionManager) : null
	};
};
